<template>
    <ins
        class="kakao_ad_area"
        style="display: none"
        data-ad-unit="DAN-Puk9Rhjmte66FeDx"
        data-ad-width="320"
        data-ad-height="100"
    ></ins>
</template>

<script>
import { defineComponent, onMounted } from "vue";

export default defineComponent({
    name: "KakaoAds",
    setup() {
        onMounted(() => {
            (window.kakao_ad_area = window.kakao_ad_area || []).push({});
        });
    },
});
</script>
